/* KA search drawer (R37 T43). The open/close, Escape, dim-area click and scroll lock
   come from dialog-component (assets/dialog.js). This file adds the three things it
   does not do: focus the input on open, keep Tab inside while open, and give focus
   back to the search button that opened it. */
(function () {
  var host = document.getElementById('ka-search-drawer');
  if (!host) return;
  var dialog = host.querySelector('dialog');
  var opener = null;

  function focusables() {
    return Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button, input, [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && !el.hidden && el.offsetParent !== null; }
    );
  }

  /* remember the control that opened it (the click lands before showModal) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[on\\:click="#ka-search-drawer/showDialog"]');
    if (btn) opener = btn;
  }, true);

  host.addEventListener('dialog:open', function () {
    var input = dialog.querySelector('.ka-sd__input');
    if (input) input.focus({ preventScroll: true });
  });

  host.addEventListener('dialog:close', function () {
    if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
  });

  dialog.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !dialog.open) return;
    var list = focusables();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();
